import { JobPosition } from "JobPosition/Domain/Model/JobPosition";
import { PermissionGroup } from "PermissionGroup/Domain/Model/PermissionGroup";
import { User } from "User/Domain/Model/User";

export class PositionOrgChart {
  constructor(id, name, jobPosition, prlPosition, permissionGroup, deletedAt) {
    this.id = id;
    this.name = name;
    this.jobPosition = jobPosition;
    this.permissionGroup = permissionGroup;
    this.deletedAt = deletedAt;
    this.users = null;
  }

  static createFromResponseData(data) {
    return new PositionOrgChart(
      data.id,
      data.name,
      data.jobPosition ? JobPosition.createFromResponseData(data.jobPosition) : null,
      data.permissionGroup ? PermissionGroup.createFromResponseData(data.permissionGroup) : null,
      data.deletedAt
    );
  }

  async loadUsers(apiClient) {
    if (this.users === null) {
      const response = await apiClient.get(`/positionOrgChart/${this.id}/users`);
      this.users = response.data.map(user => User.createFromResponseData(user));
    }
  }
}
